export default __webpack_public_path__ + "static/media/gear-limit.d649af0a.svg";